export default function DebugDiv({children}) {
    return (<div className="absolute top-0 right-0 opacity-50 bg-rose-800 text-rose-100 text-xs p-0.5">{children}</div>);
}
